import useContextWithErrorHandler from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/@common/hooks/use-context-with-error-handler';
import { OverlayContext } from '@monorepo/shared/src/providers/OverlayProvider';
import { UseOverlay } from '@monorepo/shared/src/providers/OverlayProvider/types';

const useOverlay = (): UseOverlay => {
  const [state, dispatch] = useContextWithErrorHandler(OverlayContext, 'OverlayProvider');

  return [state, dispatch];
};

export default useOverlay;
